const CheckIcon = () => {
  return (
    <svg
      width="28"
      height="28"
      viewBox="0 0 28 28"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M14 0C21.7322 0 28 6.2678 28 14C28 21.7322 21.7322 28 14 28C6.2678 28 0 21.7322 0 14C0 6.2678 6.2678 0 14 0ZM18.508 9.758L12.25 16.016L9.492 13.258C9.29295 13.0725 9.02969 12.9716 8.75767 12.9764C8.48565 12.9812 8.22611 13.0914 8.03373 13.2837C7.84135 13.4761 7.73115 13.7356 7.72636 14.0077C7.72156 14.2797 7.82253 14.543 8.008 14.742L11.508 18.242C11.7049 18.4386 11.9717 18.5491 12.25 18.5491C12.5283 18.5491 12.7951 18.4386 12.992 18.242L19.992 11.242C20.0952 11.1459 20.1779 11.03 20.2353 10.9012C20.2927 10.7724 20.3235 10.6333 20.326 10.4923C20.3285 10.3513 20.3026 10.2113 20.2498 10.0806C20.197 9.94982 20.1184 9.83105 20.0187 9.73135C19.9189 9.63164 19.8002 9.55304 19.6694 9.50023C19.5387 9.44742 19.3987 9.42148 19.2577 9.42397C19.1167 9.42646 18.9776 9.45732 18.8488 9.51471C18.72 9.57209 18.6041 9.65484 18.508 9.758Z"
        fill="url(#paint0_linear_600_221)"
      />
      <defs>
        <linearGradient
          id="paint0_linear_600_221"
          x1="3.94104"
          y1="5.60822e-07"
          x2="24.059"
          y2="28"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#FF9615" />
          <stop offset="1" stopColor="#FFCE93" />
        </linearGradient>
      </defs>
    </svg>
  );
};
export default CheckIcon;
